import React from "react";
import Modal from "../../Modal";
import ModalSessionContent from "./ModalContent";

export const MODAL_SESSION_NAME = "modal-session";
export const SESSION_EVENT_KEY = "session-event";

export const SESSION_EVENTS = {
  CONTINUE: "continue",
  LOGOUT: "logout"
};

const ModalSession = ({ onModalClose }) => {
  return (
    <Modal name={MODAL_SESSION_NAME} size="small" closable={false}>
      <ModalSessionContent onModalClose={onModalClose} />
    </Modal>
  );
};

export default ModalSession;
